import React from 'react'
import { useLocation } from 'react-router';
import {Container} from './styled';
import GlobalStyle from '../../styles/onlyHeader';

const Footer = () => {
    const location = useLocation();
    const urlWithHeader = ['/politica-de-cookies', '/contato'];    

    return (
        <>
            {urlWithHeader.includes(location.pathname) &&
                <>
                    <Container id="footer" className="bg-branco">
                        <p>© {new Date().getFullYear()} Sultan Veste a Casa. Todos os direitos reservados.</p>
                    </Container>
                    <GlobalStyle/>
                </>
            }
        </>
    )
}

export default Footer;